import React from 'react';

import { NotFound } from 'src/components/common/notFound/NotFound';
import { UpgradeButton } from 'src/components/upgradeButton/UpgradeButton';
import { useCurrentAccountId } from 'src/hooks/useCurrentAccountId';

export const FeatureUnavailable = () => {
  const currentAccountId = useCurrentAccountId()[0] || '';
  return (
    <NotFound
      title="Feature not available"
      subtitle={
        <>
          <p>This feature is not available on your current plan.</p>
          {currentAccountId ? (
            <p>
              Please{' '}
              <UpgradeButton
                className="text-link"
                accountId={currentAccountId}
                variant="buttonLink"
              >
                upgrade now
              </UpgradeButton>
              .
            </p>
          ) : (
            'Please upgrade your account.'
          )}
        </>
      }
    />
  );
};
